export default class EnterManagement {
   constructor() {
      this.enterDisabled = 0;
   }
   handleKeyDown(view, event) {
      if (event.key === 'Enter') {
         return this.enterDisabled > 0;
      }
   }

   disable() {
      this.enterDisabled += 1;
   }

   enable() {
      if (this.enterDisabled > 0) {
         this.enterDisabled -= 1;
      }
   }
}
